import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { R as g, P as N, O as C, C as b, a as f, T as I } from "../../../../index-C_B_B--s.js";
import { c as t } from "../../../../clsx-OuTLNxxd.js";
import { I as s } from "../../../../icon-D_HK7aSj.js";
import "../../icon/iconsList.js";
import { useImageCarousel as k } from "./imageCarousel.hook.js";
const z = "_modal_1a2ur_29", R = "_arrow_1a2ur_121", j = "_prev_1a2ur_132", O = "_next_1a2ur_136", r = {
  "modal-overlay": "_modal-overlay_1a2ur_29",
  "overlay-show": "_overlay-show_1a2ur_1",
  modal: z,
  "content-show": "_content-show_1a2ur_1",
  "desktop-content-show": "_desktop-content-show_1a2ur_1",
  "modal-content": "_modal-content_1a2ur_62",
  "modal-header": "_modal-header_1a2ur_65",
  "modal-title": "_modal-title_1a2ur_77",
  "modal-close": "_modal-close_1a2ur_93",
  "current-slide": "_current-slide_1a2ur_109",
  "slider-container": "_slider-container_1a2ur_115",
  arrow: R,
  prev: j,
  next: O,
  "slider-wrapper": "_slider-wrapper_1a2ur_140",
  "slider-item": "_slider-item_1a2ur_144",
  "dialog-overlay-show": "_dialog-overlay-show_1a2ur_1",
  "dialog-content-show": "_dialog-content-show_1a2ur_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1a2ur_1"
};
function E({
  images: o = [],
  isOpen: d,
  openSlide: i,
  closeLabel: _,
  className: m,
  onClose: h,
  onChange: u,
  ...p
}) {
  const { handleChange: v, currentIndex: n, move: c, sliderRef: w } = k(
    o.length,
    d,
    i,
    h,
    u
  ), x = [...o].sort((l, y) => l.order_display - y.order_display);
  return /* @__PURE__ */ e(g, { open: d, onOpenChange: v, ...p, children: /* @__PURE__ */ a(N, { children: [
    /* @__PURE__ */ e(C, { className: r["modal-overlay"] }),
    /* @__PURE__ */ a(b, { className: t(r.modal, m), children: [
      /* @__PURE__ */ a("div", { className: r["modal-header"], children: [
        /* @__PURE__ */ e(f, { asChild: !0, children: /* @__PURE__ */ a("button", { className: r["modal-close"], "aria-label": "Close", children: [
          /* @__PURE__ */ e(s, { name: "remove", color: "inverted", size: "large" }),
          " ",
          /* @__PURE__ */ e("span", { children: _ })
        ] }) }),
        /* @__PURE__ */ e(I, { className: r["modal-title"], children: /* @__PURE__ */ e("span", { children: o[n].title }) })
      ] }),
      /* @__PURE__ */ e("div", { className: r["modal-content"], children: /* @__PURE__ */ a("div", { className: r["slider-container"], children: [
        /* @__PURE__ */ e("div", { className: r["slider-wrapper"], ref: w, children: x.map((l) => /* @__PURE__ */ e("div", { className: r["slider-item"], children: /* @__PURE__ */ e("img", { src: l.src, alt: l.title ?? "" }) }, l.src)) }),
        n !== o.length - 1 && /* @__PURE__ */ e(
          "button",
          {
            className: t(r.arrow, r.next),
            color: "secondary",
            onClick: () => c("next"),
            "aria-label": "carouse-next-button",
            children: /* @__PURE__ */ e(s, { name: "circle-right-arrow", color: "inverted", size: "5xl" })
          }
        ),
        n !== 0 && /* @__PURE__ */ e(
          "button",
          {
            className: t(r.arrow, r.prev),
            color: "secondary",
            onClick: () => c("prev"),
            "aria-label": "carouse-next-button",
            children: /* @__PURE__ */ e(s, { name: "circle-right-arrow", color: "inverted", size: "5xl" })
          }
        )
      ] }) }),
      /* @__PURE__ */ a("span", { className: r["current-slide"], children: [
        n + 1,
        "/",
        o.length
      ] })
    ] })
  ] }) });
}
export {
  E as ImageCarousel
};
